/**
 * Height of the header of the conversation portion of the messaging page.
 * For context, the header contains the back button on mobile and tablet
 * devices, the user avatar and name, and a right oriented kebab menu.
 */
export const HEADER_HEIGHT = 64;
